import { render, staticRenderFns } from "./payment-asaas.vue?vue&type=template&id=6f591d36&scoped=true"
import script from "./payment-asaas.vue?vue&type=script&lang=js"
export * from "./payment-asaas.vue?vue&type=script&lang=js"
import style0 from "./payment-asaas.vue?vue&type=style&index=0&id=6f591d36&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f591d36",
  null
  
)

export default component.exports